import { useMemo } from 'preact/hooks';

export function useTimezone() {
  return useMemo(() => Intl.DateTimeFormat().resolvedOptions().timeZone, []);
}
